<template>
  <div style="display: flex;flex-flow: wrap">
    <div class="pill" v-for="(filter, index ) in activeFilters" v-bind:key="index">
      <div v-for="(color, c) in colors" v-bind:key="c">
        <span v-if="color.val === filter.val" class="pill__color"
              :style="{backgroundImage: 'url('+color.color+')'}"></span>
      </div>
      <span class="pill__title">{{ filter.title }}</span>
      <a class="pill__close" @click="removePill(filter.val,filter.name, $event)" :data-name="filter.name"
         :data-remove="true" :data-val="filter.val" href="javascript:"></a>
    </div>
  </div>
</template>

<script>
import {EventBus} from '@/vue/store';
import Global from '../../../js/_site/global';

export default {
  props: ['title', 'color', 'activeFilters'],
  methods: {
    removePill(filterVal, filterName, event) {
      const filters = Global.readCookie('activeFilters');
      const filterValues = filters.map(function(index) {
        return index.val;
      });

      if (filterValues.indexOf(filterVal) > -1) {
        filters.splice(filterValues.indexOf(filterVal), 1);
        Global.setCookie('activeFilters', filters);
      }

      const newFilters = Global.readCookie('activeFilters');
      this.activeFilters = newFilters;
      EventBus.$emit('active-filters', this.activeFilters);

      // on removed filter find that in url and remove
      let str = '';
      for (let i = 0; i < newFilters.length; i++) {
        if (str.indexOf(newFilters[i].name) > -1) {
          const position = str.indexOf(newFilters[i].name) + newFilters[i].name.length + 1;
          str = [str.slice(0, position), newFilters[i].val + '+', str.slice(position)].join('');
        } else {
          str += newFilters[i].name + '=' + newFilters[i].val + '&';
        }
        window.history.pushState({}, '', '?' + str.slice(0, -1));
      }

      if (newFilters.length === 0) {
        window.history.pushState({}, '', location.href.substr(0, location.href.indexOf('?')));
      }

      const setPageOne = location.href.replace('/' + this.sapData.pagination.currentPage + '/', '/1/');
      this.sapData.pagination.currentPage = 1;
      window.history.replaceState({}, '', setPageOne);

      Global.setCookie('filters', str.slice(0, -1));

      EventBus.$emit('trigger-results', event);
      EventBus.$emit('get-count', this.sapData.productsCount);
    },
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      colors: sapData.colors,
      // eslint-disable-next-line no-undef
      sapData: sapData
    };
  },
  created() {
    EventBus.$on('trigger-remove-pill', (val, name, event) => {
      this.removePill(val, name, event);
    });
  }
};
</script>

<style lang="scss" scoped>
.pill {
  max-width: 200px;
  position: relative;
  padding: 5px 11px;
  background-color: #ddd;
  border-radius: 13px;
  width: auto;
  height: 25px;
  margin-right: 6px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  padding: 5px 30px 5px 11px;
}

.pill__color {
  height: 11px;
  width: 11px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 11px;
}

.pill__title {
  font-size: 14px;
  color: $grey;
  font-family: $font-second;
  display: inline-block;
  text-transform: capitalize;
}

.pill__close {
  height: 11px;
  width: 11px;
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;

  &:hover {
    &::before,
    &::after {
      opacity: .5;
      transition: $dur $ease;
    }
  }

  &::before,
  &::after {
    content: '';
    @include center;
    background-color: $black;
    transition: $dur $ease;
    width: 11px;
    height: 1px;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
</style>
